export type TStepperDirection = "row" | "column";
export type TSize = "sm" | "md" | "lg";
